/** Function used to generate a unique id with a custom prefix */

export const getUniqueId = (prefix) => `${prefix}-${Math.random()}`; // nosonar
